import React, { Component } from "react";
import { Link } from "react-router-dom";
import "animate.css";
import Navbar from "../../Navbar/Navbar";
import MainBodyContainer from "../../Common/Body/MainBodyContainer/MainBodyContainer";
import Footer from "../../Footer/Footer";
import { PersonalTrainingData } from "../../Data/CommunityCoursesData";

import "./PersonalTraining.css";

class PersonalTraining extends Component {
  render() {
    const professionalTraining = PersonalTrainingData.find(
      (cat) => cat.id === "professional-training"
    );
    const lifeSkills = PersonalTrainingData.find(
      (cat) => cat.id === "life-skills"
    );

    return (
      <div className="personal-training-page">
        <Navbar />

        {/* ── Hero ── */}
        <div className="pt-hero-section">
          <div className="pt-hero-overlay"></div>
          <div className="pt-hero-content">
            <Link
              to="/training"
              className="pt-breadcrumb animate__animated animate__fadeInDown"
            >
              ← Back to Training Hub
            </Link>
            <h1 className="animate__animated animate__fadeInUp">
              Empower Your <span className="highlight-text">Future</span>
            </h1>
            <p className="pt-hero-subtitle animate__animated animate__fadeInUp animate__delay-1s">
              Professional qualifications and essential life skills — tailored to
              your unique journey and built around your life.
            </p>
            <div className="pt-hero-cta animate__animated animate__fadeInUp animate__delay-2s">
              <a href="#professional-pathway" className="pt-btn-primary">
                Explore Professional Courses
              </a>
              <a href="#life-skills-pathway" className="pt-btn-secondary">
                Discover Life Skills
              </a>
            </div>
          </div>
        </div>

        {/* ── Stats Banner — sits between hero and body ── */}
        <div className="pt-stats-wrapper">
          <div className="pt-stats-banner">
            <div className="pt-stat-item">
              <span className="pt-stat-icon">🎓</span>
              <div className="pt-stat-text">
                <strong>Accredited</strong>
                <span>Nationally Recognised</span>
              </div>
            </div>
            <div className="pt-stat-item">
              <span className="pt-stat-icon">💷</span>
              <div className="pt-stat-text">
                <strong>Funded</strong>
                <span>Support Available</span>
              </div>
            </div>
            <div className="pt-stat-item">
              <span className="pt-stat-icon">🕒</span>
              <div className="pt-stat-text">
                <strong>Flexible</strong>
                <span>Fits Around Your Life</span>
              </div>
            </div>
          </div>
        </div>

        <MainBodyContainer>
          <div className="pt-main-content">

            {/* ── Professional Training Section ── */}
            {professionalTraining && (
              <section id="professional-pathway" className="pt-pathway-section">
                <div className="pt-section-header">
                  <div className="header-badge">Career Focused</div>
                  <h2>{professionalTraining.title}</h2>
                  <p className="pt-section-desc">
                    {professionalTraining.description}
                  </p>
                  <div className="pt-who-helps">
                    <strong>Perfect for:</strong>
                    <div className="pt-tags-container">
                      {professionalTraining.whoThisHelps.map((audience, i) => (
                        <span key={i} className="pt-audience-tag">
                          {audience}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="pt-programs-grid">
                  {professionalTraining.programs.map((program, idx) => {
                    const hasFullDetails = program.modules && program.modules.length > 0;
                    return (
                      <div key={idx} className="pt-course-card">
                        <div className="pt-course-card-header">
                          <h3>{program.name}</h3>
                          {program.level && (
                            <span className="pt-course-level-badge">{program.level}</span>
                          )}
                        </div>
                        <p className="pt-course-short">{program.shortDescription}</p>

                        <div className="pt-course-details">
                          <div className="pt-detail-item">
                            <span className="detail-label">Duration</span>
                            <span className="detail-value">{program.duration}</span>
                          </div>
                          {program.employmentOutcomes && (
                            <div className="pt-detail-item">
                              <span className="detail-label">Career paths</span>
                              <span className="detail-value">
                                {program.employmentOutcomes}
                              </span>
                            </div>
                          )}
                        </div>

                        <div className="pt-course-topics">
                          <ul>
                            {program.topics.slice(0, 3).map((topic, i) => (
                              <li key={i}>{topic}</li>
                            ))}
                            {program.topics.length > 3 && (
                              <li>+{program.topics.length - 3} more topics</li>
                            )}
                          </ul>
                        </div>

                        {hasFullDetails ? (
                          <Link
                            to={`/training/personal/${professionalTraining.id}/${program.id}`}
                            className="pt-btn-card"
                          >
                            Learn more →
                          </Link>
                        ) : (
                          <span className="pt-btn-card pt-btn-card--inactive">
                            Coming soon
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="pt-category-action">
                  <Link
                    to={`/training/personal/${professionalTraining.id}`}
                    className="pt-btn-outline"
                  >
                    View Full Professional Syllabus
                  </Link>
                </div>
              </section>
            )}

            {/* ── Life Skills Section ── */}
            {lifeSkills && (
              <section
                id="life-skills-pathway"
                className="pt-pathway-section pt-life-skills-bg"
              >
                <div className="pt-section-header">
                  <div className="header-badge life-badge">Essential Skills</div>
                  <h2>{lifeSkills.title}</h2>
                  <p className="pt-section-desc">{lifeSkills.description}</p>
                  <div className="pt-who-helps">
                    <strong>Supporting:</strong>
                    <div className="pt-tags-container">
                      {lifeSkills.whoThisHelps.map((audience, i) => (
                        <span key={i} className="pt-audience-tag life-tag">
                          {audience}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="pt-programs-grid">
                  {lifeSkills.programs.map((program, idx) => {
                    const hasFullDetails = program.modules && program.modules.length > 0;
                    return (
                      <div key={idx} className="pt-course-card life-card">
                        <div className="pt-course-card-header">
                          <h3>{program.name}</h3>
                          {program.level && (
                            <span className="pt-course-level-badge life-level">{program.level}</span>
                          )}
                        </div>
                        <p className="pt-course-short">{program.shortDescription}</p>

                        <div className="pt-course-details">
                          <div className="pt-detail-item">
                            <span className="detail-label">Duration</span>
                            <span className="detail-value">{program.duration}</span>
                          </div>
                        </div>

                        <div className="pt-course-topics">
                          <ul>
                            {program.topics.map((topic, i) => (
                              <li key={i}>{topic}</li>
                            ))}
                          </ul>
                        </div>

                        {hasFullDetails ? (
                          <Link
                            to={`/training/personal/${lifeSkills.id}/${program.id}`}
                            className="pt-btn-card"
                          >
                            Learn more →
                          </Link>
                        ) : (
                          <span className="pt-btn-card pt-btn-card--inactive">
                            Coming soon
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </section>
            )}

            {/* ── Success Story + Enrollment ── */}
            <section className="pt-bottom-section">
              {lifeSkills && lifeSkills.successStory && (
                <div className="pt-success-story">
                  <div className="quote-icon">"</div>
                  <blockquote>{lifeSkills.successStory.quote}</blockquote>
                  <div className="story-author">
                    <strong>{lifeSkills.successStory.name}</strong>
                    <span>{lifeSkills.successStory.background}</span>
                  </div>
                  <div className="story-journey">
                    <strong>The Journey: </strong>
                    {lifeSkills.successStory.journey}
                  </div>
                </div>
              )}

              <div className="pt-enrollment-info">
                <h3>Ready to begin?</h3>
                <p>
                  We believe education should be accessible to everyone. Here's
                  how we support you from day one.
                </p>

                <ul className="enrollment-list">
                  <li>
                    <span className="list-icon">🎓</span>
                    <div>
                      <strong>Funding Available</strong>
                      <span>
                        Many courses are fully funded or free for eligible
                        participants.
                      </span>
                    </div>
                  </li>
                  <li>
                    <span className="list-icon">🕒</span>
                    <div>
                      <strong>Flexible Scheduling</strong>
                      <span>
                        Morning, afternoon, and evening options designed to fit
                        around your commitments.
                      </span>
                    </div>
                  </li>
                  <li>
                    <span className="list-icon">👶</span>
                    <div>
                      <strong>Childcare Support</strong>
                      <span>
                        Crèche available for select morning and afternoon
                        classes.
                      </span>
                    </div>
                  </li>
                </ul>

                <a href="#contact" className="pt-btn-primary full-width">
                  Enquire Now →
                </a>
              </div>
            </section>

          </div>
        </MainBodyContainer>

        <Footer />
      </div>
    );
  }
}

export default PersonalTraining;
